// extracted by mini-css-extract-plugin
export default {"glass":"EmailSection_glass__63kui","emailSection":"EmailSection_emailSection__V-ZPc","status":"EmailSection_status__ZbPfp","h2":"EmailSection_h2__gg+vo"};